module.exports = require("shelljs");


//////////////////
// WEBPACK FOOTER
// external "shelljs"
// module id = 1
// module chunks = 0